import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, AlertController } from 'ionic-angular';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { FormGroup, FormBuilder,Validators } from '@angular/forms';
import { LoadingProvider } from '../../providers/loading/loading';

/**
 * Generated class for the ForgetPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-forget-password',
  templateUrl: 'forget-password.html',
})
export class ForgetPasswordPage {

  forgetPassword:FormGroup;
  submitAttempt = false;


  constructor(public navCtrl: NavController, public navParams: NavParams, private menu: MenuController, private auth: RequestServiceProvider,private formBuilder: FormBuilder, private alertCtrl: AlertController, private load: LoadingProvider) {

    this.forgetPassword = this.formBuilder.group({
      agentId: ['',Validators.required],


  });



  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgetPasswordPage');
  }


  resetPassword(){
    this.submitAttempt = true;

    if(this.forgetPassword.valid){
      this.load.presentLoading('Loading...');
      this.auth.postForgetPassword(this.forgetPassword.value.agentId).subscribe(
        data => {
          this.load.loader.dismiss().catch(()=>{});
          this.presentAlert("Password Reset Successful",data.json().message)
        },
        error =>{
          this.load.loader.dismiss().catch(()=>{});
          console.log(error.json().message);
          this.presentAlert("Password Reset Failed",error.json().message)
        }
      )
    }
  }


  presentAlert(title, message){
    let alert = this.alertCtrl.create({
      title:title,
      subTitle:message,
      buttons:['OK']
    });
    alert.present();
  }



  ionViewWillEnter(){
    this.menu.enable(false);
    this.menu.swipeEnable(false);
  }
}



// WEBPACK FOOTER //
// ./src/pages/forget-password/forget-password.ts